<div class="app container grid-lg">
    <header class="navbar">
        <section class="navbar-section">
            <a href="#" class="navbar-brand mr-2">Monotonous</a>
            <a href="javascript:void(0);" (click)="showAbout = !showAbout" class="btn btn-link">About</a>
        </section>
    </header>
    <main>
        <ng-container [formGroup]="form">
            <div class="separator-settings" [class.has-error]="form.hasError('separatorsAreSame')">
                <div class="separator-input">
                    <div class="form-group form-inline">
                        <label class="form-label" for="columnSeparator">Column separator</label>
                        <input class="form-input" id="columnSeparator" formControlName="columnSeparator" />
                    </div>
                    <div class="form-group form-inline">
                        <label class="form-label" for="rowSeparator">Row separator</label>
                        <input class="form-input" id="rowSeparator" formControlName="rowSeparator" />
                    </div>
                </div>
                <div class="separator-error">
                    <p class="form-input-hint" *ngIf="form.hasError('separatorsAreSame')">Separators can't be the same</p>
                </div>
            </div>
            <div class="inputs">
                <div class="form-group">
                    <div class="label-help">
                        <label class="form-label" for="input">Input</label>
                        <button class="btn btn-help" type="button" (click)="showInputHelp = !showInputHelp">
              ?
            </button>
                    </div>
                    <ngx-monaco-editor [options]="editorOptions" class="form-input" formControlName="input"></ngx-monaco-editor>
                </div>

                <div class="form-group">
                    <div class="label-help with-actions">
                        <div class="label-help--text-button">
                            <label class="form-label" for="format">Format</label>
                            <button class="btn btn-help" type="button" (click)="showFormatHelp = !showFormatHelp">
                ?
              </button>
                        </div>
                        <div class="label-help--actions">
                            <button class="btn btn-format-history" type="button" (click)="showFormatHistory = !showFormatHistory">
                history
              </button>
                        </div>
                    </div>
                    <ngx-monaco-editor [options]="editorOptions" class="form-input" formControlName="format"></ngx-monaco-editor>
                </div>

                <div class="form-group">
                    <div class="label-help with-actions">
                        <div class="label-help--text-button">
                            <label class="form-label" for="format">Output</label>
                        </div>
                        <div class="label-help--actions">
                            <button class="btn" type="button" [copy-clipboard]="form.value.output">
                Copy output
              </button>
                        </div>
                    </div>
                    <!-- <input type="hidden" [value]="output$ | async" /> -->
                    <ngx-monaco-editor [options]="editorOptions" class="form-input" formControlName="output"></ngx-monaco-editor>
                </div>
            </div>
        </ng-container>
    </main>
    <footer>&copy;<a href="mailto:thomasking@live.be">Thomas King</a></footer>
</div>
<ng-container *ngIf="showAbout">
    <div class="modal active" id="modal-id">
        <a href="#close" class="modal-overlay" aria-label="Close" (click)="showAbout = !showAbout"></a>
        <div class="modal-container">
            <div class="modal-header">
                <a href="#close" role="button" tabindex="0" class="btn btn-clear float-right" (click)="showAbout = !showAbout" aria-label="Close"></a>
                <div class="modal-title h5">About Monotonous</div>
            </div>
            <div class="modal-body">
                <div class="content" ngNonBindable>
                    <p>
                        Ever had to write very monotonous, repetitive code? For example, you have...
                    </p>
                    <ul>
                        <li>... an interface and for each property you have to write the same function but with the name of that property</li>
                        <li>... a list of names, countries, etc. but need to surround each item with a specific &lt;div&gt; tag</li>
                        <li>... several rows of data and want to write an insert query for each row (e.g. in SQL Server)</li>
                    </ul>
                    <p>
                        I know I have! That's why I've created <em>Monotonous</em>. With Monotonous you can input a list of something and output each item of that list to the supplied format. This can easily hasten that monotonous coding you've been doing!
                        Go ahead and try it out 😄!
                    </p>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="showInputHelp">
    <div class="modal active" id="modal-id">
        <a href="#close" class="modal-overlay" aria-label="Close" (click)="showInputHelp = !showInputHelp"></a>
        <div class="modal-container">
            <div class="modal-header">
                <a href="#close" role="button" tabindex="0" class="btn btn-clear float-right" (click)="showInputHelp = !showInputHelp" aria-label="Close"></a>
                <div class="modal-title h5">Input help</div>
            </div>
            <div class="modal-body">
                <div class="content">
                    <p>
                        Write your input in this textarea. The input will be divided into columns and rows according to the separators defined on top. By default columns are divided by "{{ columnSeparator$ | async }}" and rows by "{{ unterpret(rowSeparator$ | async) }}".
                    </p>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="showFormatHelp">
    <div class="modal active" id="modal-id">
        <a href="#close" class="modal-overlay" aria-label="Close" (click)="showFormatHelp = !showFormatHelp"></a>
        <div class="modal-container">
            <div class="modal-header">
                <a href="#close" role="button" tabindex="0" class="btn btn-clear float-right" (click)="showFormatHelp = !showFormatHelp" aria-label="Close"></a>
                <div class="modal-title h5">Format help</div>
            </div>
            <div class="modal-body">
                <div class="content" ngNonBindable>
                    <p>
                        Write the format to be applied to the input in this textarea. For each row defined by the input, the format will be applied. Use the dollar sign together with the column index (zero-based) to insert the value in this specific spot. E.g. <code>$0 is cool</code>                        will insert the value of the first column for each row in this format.
                    </p>
                    <p>
                        You can also make use of interpolation and use JavaScript functions (such as toUpperCase, toLowerCase, Math.random(),...). E.g.:
                        <code>{{ $0.toUpperCase() }}</code> will output the first column for each row in uppercase.
                    </p>
                    <p>
                        Lodash (v4.17.19) is available as well. Use it by assigning your value to <code>lodash</code> and calling the specific lodash function on that. E.g.: <code>{{ lodash($0).upperFirst() }}</code>.
                    </p>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="showFormatHistory">
    <div class="modal active" id="modal-id">
        <a href="#close" class="modal-overlay" aria-label="Close" (click)="showFormatHistory = !showFormatHistory"></a>
        <div class="modal-container">
            <div class="modal-header">
                <a href="#close" role="button" tabindex="0" class="btn btn-clear float-right" (click)="showFormatHistory = !showFormatHistory" aria-label="Close"></a>
                <div class="modal-title h5">Format history</div>
            </div>
            <div class="modal-body">
                <div class="content">
                    <table class="table table-striped table-hover format-history-table" *ngIf="(formats$ | async) as formats else noHistoryYet">
                        <tbody>
                            <tr *ngFor="let format of formats">
                                <td>{{ format }}</td>
                                <td class="text-right">
                                    <button class="btn" type="button" (click)="selectFormatFromHistory(format)">
                    select
                  </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <ng-template #noHistoryYet>
        <p class="text-center">No history yet!</p>
    </ng-template>
</ng-container>